import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import alert from './modules/alert'
import clients from './modules/clients'
import products from './modules/products'
import routes from './modules/routes'
import employees from './modules/employees'
import vehicles from './modules/vehicles'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    alert,
    clients,
    products,
    routes,
    employees,
    vehicles
  }
})
